import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Linkedin, CheckCircle2 } from 'lucide-react';
export function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 bg-navy text-offwhite" data-id="element-68">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-70">
          <div className="lg:col-span-5" data-id="element-71">
            <h2 className="font-serif text-3xl md:text-4xl mb-6" data-id="element-72">
              Get in Touch
            </h2>
            <div className="w-16 h-px bg-gold mb-10" data-id="element-73"></div>

            <p className="text-gray-400 mb-10 leading-relaxed" data-id="element-74">
              Available for Non-Executive Director and Chair appointments, as
              well as strategic advisory roles focusing on the energy
              transition, M&A, and corporate governance.
            </p>

            <div className="space-y-6" data-id="element-75">
              <a href="mailto:rmoblath@gmail.com" className="flex items-center space-x-4 group" data-id="element-76">
                <div className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center group-hover:border-gold group-hover:text-gold transition-colors" data-id="element-77">
                  <Mail size={18} data-id="element-78" />
                </div>
                <span className="text-gray-300 group-hover:text-white transition-colors" data-id="element-79">
                  rmoblath@gmail.com
                </span>
              </a>

              <a href="tel:+447380968855" className="flex items-center space-x-4 group" data-id="element-80">
                <div className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center group-hover:border-gold group-hover:text-gold transition-colors" data-id="element-81">
                  <Phone size={18} data-id="element-82" />
                </div>
                <span className="text-gray-300 group-hover:text-white transition-colors" data-id="element-83">
                  +44 (0)7380 968 855
                </span>
              </a>

              <div className="flex items-center space-x-4" data-id="element-84">
                <div className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center text-gray-400" data-id="element-85">
                  <MapPin size={18} data-id="element-86" />
                </div>
                <span className="text-gray-300" data-id="element-87">Cornwall, UK</span>
              </div>

              <a href="https://www.linkedin.com/in/richard-m-oblath-phd-ceng-fimmm-090ab924/" target="_blank" rel="noopener noreferrer" aria-label="Connect with Richard M Oblath on LinkedIn (opens in a new tab)" className="flex items-center space-x-4 group pt-4" data-id="element-88">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white group-hover:bg-blue-700 transition-colors" data-id="element-89">
                  <Linkedin size={18} data-id="element-90" />
                </div>
                <span className="text-gray-300 group-hover:text-white transition-colors" data-id="element-91">
                  Connect on LinkedIn
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-92">
            <div className="bg-navy-light p-8 md:p-10 border border-gray-800" data-id="element-93">
              <h3 className="font-serif text-2xl mb-8" data-id="element-94">Send a Message</h3>
              {submitted ? <div className="flex flex-col items-center text-center py-12" data-id="element-95">
                  <CheckCircle2 size={48} className="text-gold mb-6" data-id="element-96" />
                  <h4 className="font-serif text-xl mb-3" data-id="element-97">Message Received</h4>
                  <p className="text-gray-400 text-sm max-w-sm leading-relaxed" data-id="element-98">
                    Thank you for reaching out. Your message has been noted and
                    a response will follow at the earliest opportunity.
                  </p>
                </div> : <form className="space-y-6" onSubmit={handleSubmit} data-id="element-99">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-100">
                    <div data-id="element-101">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-102">
                        Name
                      </label>
                      <input type="text" id="name" required value={form.name} onChange={handleChange} className="w-full bg-navy border border-gray-700 rounded-none px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="Jane Doe" data-id="element-103" />
                    </div>
                    <div data-id="element-104">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-105">
                        Email
                      </label>
                      <input type="email" id="email" required value={form.email} onChange={handleChange} className="w-full bg-navy border border-gray-700 rounded-none px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="jane@example.com" data-id="element-106" />
                    </div>
                  </div>
                  <div data-id="element-107">
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-108">
                      Subject
                    </label>
                    <input type="text" id="subject" value={form.subject} onChange={handleChange} className="w-full bg-navy border border-gray-700 rounded-none px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors" placeholder="Board Opportunity" data-id="element-109" />
                  </div>
                  <div data-id="element-110">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-111">
                      Message
                    </label>
                    <textarea id="message" rows={4} required value={form.message} onChange={handleChange} className="w-full bg-navy border border-gray-700 rounded-none px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors resize-none" placeholder="How can we work together?" data-id="element-112"></textarea>
                  </div>
                  <button type="submit" className="px-8 py-4 bg-gold text-navy font-medium hover:bg-gold-light transition-colors duration-300 w-full md:w-auto" data-id="element-113">
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}